import { Form, Input, Select, Button, Row, Col, Space, Modal, message, Tabs, Alert } from "antd";
import { CloseOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import AnimateItems from "../../../../utils/AnimateItems";
import { tipospersona, nacionalidades } from "../formOptions";
import axios from "axios";
import DatoForm from "../persona/DatoForm";
import CorreoForm from "../persona/CorreoForm";
import TelefonoForm from "../persona/TelefonoForm";

export default function PersonaForm(props) {
  const {
    setPersonasList,
    setDatosPersona,
    setTelefonosFijos,
    setTelefonosMoviles,
    setCorreosPersona,
    personaEditing,
    personaFormVisible,
    setPersonaFormVisible,
    origin,
    setFoliosPersona,
    setDomiciliosPersona,
  } = props;
  const [form] = Form.useForm();
  const [infoDatos, setInfoDatos] = useState();
  const [infoTelefonos, setInfoTelefonos] = useState();
  const [infoCorreos, setInfoCorreos] = useState();
  const [isFisicaHidden, setIsFisicaHidden] = useState(true);
  const [isMoralHidden, setIsMoralHidden] = useState(true);
  const [internalPersonaID, setInternalPersonaID] = useState(personaEditing);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [personaName, setPersonaName] = useState("");
  const [activeKey, setActiveKey] = useState("1");
  const moralRef = useRef();
  const fisicaRef = useRef();

  useEffect(() => {
    setInternalPersonaID(personaEditing);
    setShowSuccessAlert(false);
    setActiveKey("1");
    if (!personaEditing) setPersonaName("");
  }, [personaEditing, personaFormVisible]);

  useEffect(() => {
    if (internalPersonaID) {
      Promise.all([
        axios.get(`${process.env.REACT_APP_API_URL}/personas/${internalPersonaID}`),
        axios.get(`${process.env.REACT_APP_API_URL}/datos/persona/${internalPersonaID}`),
        axios.get(`${process.env.REACT_APP_API_URL}/telefonos/persona/${internalPersonaID}`),
        axios.get(`${process.env.REACT_APP_API_URL}/correos/persona/${internalPersonaID}`),
      ])
        .then(([p, d, t, c]) => {
          const person = p.data[0];
          form.setFieldsValue(person);
          setPersonaName(person.TipoPersonaID === 1 ? `${person.Nombre || ""} ${person.ApellidoPaterno || ""} ${person.ApellidoMaterno || ""}`.trim() : person.RazonSocial);
          setInfoDatos(d.data);
          setInfoTelefonos(t.data);
          setInfoCorreos(c.data);
          if (p.data[0].TipoPersonaID === 1) {
            setIsFisicaHidden(false);
            setIsMoralHidden(true);
          } else if (p.data[0].TipoPersonaID === 2) {
            setIsMoralHidden(false);
            setIsFisicaHidden(true);
          } else {
            setIsFisicaHidden(true);
            setIsMoralHidden(true);
          }
        })
        .catch((error) => {
          console.log(error);
          message.error(error.message);
        });
    } else {
      form.resetFields();
      form.setFieldsValue({ NacionalidadID: 2 });
      setIsFisicaHidden(true);
      setIsMoralHidden(true);
      setInfoDatos(null);
      setInfoTelefonos(null);
      setInfoCorreos(null);
    }
  }, [internalPersonaID, form, personaFormVisible]);

  useEffect(() => {
    if (isFisicaHidden) {
      moralRef.current?.focus();
      form.setFieldsValue({
        Nombre: null,
        ApellidoPaterno: null,
        ApellidoMaterno: null,
      });
    } else if (isMoralHidden) {
      fisicaRef.current?.focus();
      form.setFieldsValue({
        RazonSocial: null,
      });
    }
  }, [form, isFisicaHidden, isMoralHidden]);

  const clearSelectProps = {
    style: { width: "100%" },
    allowClear: true,
    clearIcon: <CloseOutlined style={{ color: "red" }} />,
    showSearch: true,
    filterOption: (input, option) => option.children?.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0,
  };

  const onEditSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        axios
          .put(`${process.env.REACT_APP_API_URL}/personas/${internalPersonaID}`, values)
          .then((response) => {
            setPersonaFormVisible(false);
            message.success("Persona editada con éxito");
            axios
              .get(`${process.env.REACT_APP_API_URL}/personas`)
              .then((response) => {
                setPersonasList(response.data);
                message.success("Lista de personas actualizada con éxito");
              })
              .catch((error) => {
                console.log("Error gettting personas", error);
                message.error("Error actualizando lista de personas");
              });
          })
          .catch((error) => {
            console.log("Request failed", error);
            message.error("Error editando persona");
          });
      })
      .catch((error) => {
        console.log("Validation error", error);
        message.warning("Por favor complete los campos requeridos");
      });
  };

  const onAddSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        axios
          .post(`${process.env.REACT_APP_API_URL}/personas`, values)
          .then((response) => {
            message.success("Persona agregada con éxito");
            // Set internal ID to enable other tabs without closing
            setInternalPersonaID(response.data.insertId);
            setPersonaName(values.TipoPersonaID === 1 ? `${values.Nombre || ""} ${values.ApellidoPaterno || ""} ${values.ApellidoMaterno || ""}`.trim() : values.RazonSocial);
            setShowSuccessAlert(true);
            axios
              .get(`${process.env.REACT_APP_API_URL}/personas`)
              .then((response) => {
                setPersonasList(response.data);
              })
              .catch((error) => {
                console.log("Error gettting personas", error);
                message.error("Error actualizando lista de personas");
              });
          })
          .catch((error) => {
            console.log("Request failed", error);
            message.error("Error agregando persona");
          });
      })
      .catch((error) => {
        console.log("Validation error", error);
        message.warning("Por favor complete los campos requeridos");
      });
  };

  const clearForm = () => {
    form.resetFields();
  };

  const handleClose = () => {
    if (props.onClose && internalPersonaID) {
      props.onClose(internalPersonaID);
    }
    setPersonaFormVisible(false);
  };

  const isTabDisabled = !internalPersonaID;
  const isNewlyAdded = internalPersonaID && (personaEditing === null || personaEditing === undefined);

  return (
    <>
      <Modal 
        title={internalPersonaID ? `Editando ${personaName}` : "Agregando persona nueva"} 
        visible={personaFormVisible} 
        onCancel={handleClose} 
        footer={
          <div style={{ textAlign: "right" }}>
            <Space>
              {activeKey === "1" ? (
                <>
                  <Button
                    type="primary"
                    onClick={() => {
                      internalPersonaID ? onEditSubmit() : onAddSubmit();
                    }}
                  >
                    {internalPersonaID ? "ACTUALIZAR INFORMACIÓN GENERAL" : "GUARDAR Y CONTINUAR"}
                  </Button>
                  <Button
                    onClick={() => {
                      clearForm();
                      handleClose();
                    }}
                  >
                    {internalPersonaID ? "Cerrar" : "Cancelar"}
                  </Button>
                </>
              ) : (
                <Button
                  type="primary"
                  onClick={handleClose}
                >
                  CERRAR Y ACTUALIZAR
                </Button>
              )}
            </Space>
          </div>
        } 
        centered 
        width={700}
      >
        <Tabs 
          activeKey={activeKey}
          onChange={(key) => setActiveKey(key)}
          className={`${isNewlyAdded && showSuccessAlert ? "tabs-animated" : ""} persona-modal-tabs`}
        >
          <Tabs.TabPane 
            tab={
              <span>
                {isNewlyAdded && internalPersonaID && <CheckCircleOutlined style={{ color: "#52c41a", marginRight: 8 }} />}
                General
              </span>
            } 
            key="1"
          >
            <Form form={form} layout="vertical">
              <AnimateItems delay={0.15}>
                <AnimatePresence>
                  {showSuccessAlert && isNewlyAdded && (
                    <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, height: 0 }}
                      style={{ marginBottom: 16 }}
                    >
                      <Alert
                        message="Información general guardada. Ya puedes completar las demás pestañas."
                        type="info"
                        showIcon
                        style={{ borderRadius: "8px", border: "1px solid #91d5ff", backgroundColor: "#e6f7ff" }}
                        closable
                        onClose={() => setShowSuccessAlert(false)}
                      />
                    </motion.div>
                  )}
                </AnimatePresence>
                <Form.Item name="NacionalidadID" label="Nacionalidad" rules={[{ required: true, message: "Elige una nacionalidad" }]}>
                  <Select {...clearSelectProps}>
                    {nacionalidades.map((nacionalidad) => (
                      <Select.Option key={nacionalidad.value} value={nacionalidad.value}>
                        {nacionalidad.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="TipoPersonaID" label="Tipo de persona" rules={[{ required: true, message: "Elige el tipo de persona" }]}>
                  <Select
                    {...clearSelectProps}
                    onChange={(value) => {
                      setTimeout(() => {
                        if (value === 1) {
                          setIsFisicaHidden(false);
                          setIsMoralHidden(true);
                        } else if (value === 2) {
                          setIsMoralHidden(false);
                          setIsFisicaHidden(true);
                        } else {
                          setIsFisicaHidden(true);
                          setIsMoralHidden(true);
                        }
                      }, 350);
                    }}
                  >
                    {tipospersona.map((tipo) => (
                      <Select.Option key={tipo.value} value={tipo.value}>
                        {tipo.label}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item 
                  name="Nombre" 
                  label="Nombre" 
                  rules={[{ required: !isFisicaHidden, message: "Escribe el nombre" }]} 
                  hidden={isFisicaHidden}
                >
                  <Input ref={fisicaRef} />
                </Form.Item>
                <Row gutter={[8, 8]}>
                  <Col span={12}>
                    <Form.Item
                      name="ApellidoPaterno"
                      label="Apellido paterno"
                      rules={[{ required: !isFisicaHidden, message: "Escribe el apellido paterno" }]}
                      hidden={isFisicaHidden}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="ApellidoMaterno"
                      label="Apellido materno"
                      rules={[{ required: !isFisicaHidden, message: "Escribe el apellido materno" }]}
                      hidden={isFisicaHidden}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item
                  name="RazonSocial"
                  label="Razón social"
                  rules={[{ required: !isMoralHidden, message: "Escribe la razón social" }]}
                  hidden={isMoralHidden}
                >
                  <Input ref={moralRef} />
                </Form.Item>
              </AnimateItems>
            </Form>
          </Tabs.TabPane>
          {/* ----------------------------- DATOS ----------------------------- */}
          <Tabs.TabPane tab="Identificaciones" key="2" disabled={isTabDisabled}>
            <Space direction="vertical" style={{ width: "100%" }}>
              {infoDatos?.map((dato) => (
                <DatoForm
                  key={dato.DatoID}
                  dato={dato}
                  personaEditing={internalPersonaID}
                  type="edit"
                  setInfoDatos={setInfoDatos}
                  setDatosPersona={setDatosPersona}
                  origin={origin}
                  setFoliosPersona={setFoliosPersona}
                  setDomiciliosPersona={setDomiciliosPersona}
                />
              ))}
              <DatoForm personaEditing={internalPersonaID} type="add" setInfoDatos={setInfoDatos} setDatosPersona={setDatosPersona} />
            </Space>
          </Tabs.TabPane>
          {/* ----------------------------- TELEFONOS ----------------------------- */}
          <Tabs.TabPane tab="Teléfonos" key="3" disabled={isTabDisabled}>
            <Space direction="vertical" style={{ width: "100%" }}>
              {infoTelefonos?.map((telefono) => (
                <TelefonoForm
                  key={telefono.TelefonoID}
                  telefono={telefono}
                  personaEditing={internalPersonaID}
                  type="edit"
                  setInfoTelefonos={setInfoTelefonos}
                  setTelefonosFijos={setTelefonosFijos}
                  setTelefonosMoviles={setTelefonosMoviles}
                />
              ))}
              <TelefonoForm
                personaEditing={internalPersonaID}
                type="add"
                setInfoTelefonos={setInfoTelefonos}
                setTelefonosFijos={setTelefonosFijos}
                setTelefonosMoviles={setTelefonosMoviles}
              />
            </Space>
          </Tabs.TabPane>
          {/* ----------------------------- CORREOS ----------------------------- */}
          <Tabs.TabPane tab="Correos" key="4" disabled={isTabDisabled}>
            <Space direction="vertical" style={{ width: "100%" }}>
              {infoCorreos?.map((correo) => (
                <CorreoForm
                  key={correo.CorreoID}
                  correo={correo}
                  personaEditing={internalPersonaID}
                  type="edit"
                  setInfoCorreos={setInfoCorreos}
                  setCorreosPersona={setCorreosPersona}
                />
              ))}
              <CorreoForm
                personaEditing={internalPersonaID}
                type="add"
                setInfoCorreos={setInfoCorreos}
                setCorreosPersona={setCorreosPersona}
              />
            </Space>
          </Tabs.TabPane>
        </Tabs>
      </Modal>
    </>
  );
}
